import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setRegPage, popupOpenClose, getGuestInRoom, currentWidget, setFailScreen } from '../../../action/action'
import { guestBillDetails, setDefaultBill, getServiceID, guestHistroy, checkOut, extendStay } from '../../../action/viewBillAction'
import { confirmationPop, SetSelectedGuest, sendGuestMail, setSuccessFailPop } from '../../action/viewBillAction2'
import { openClosePopUp, setGoHome, setLoaderPopUp, setLoginRequired } from '../../action/homeAction'
import { widgetColors } from '../../JS/colorConfig'
import { scrollToTop } from '../../../JS/scrollToTop'
import LoaderPopUp from '../../../layout2.0/UI/loaderPopUp'
import { scrollUpListener, scrollDownEffect, removeScrollDown } from '../roomControl2/scrollEffect';
import $ from 'jquery'
import { DEMO, CMSPath, ENABLE_NEW_CHECKOUT_FLOW, HIDE_EMAIL_FIELD_ON_CHECKOUT, CLICKED, EXIT } from '../../../config/constant'
import Loader from '../../UI/loader';
import {withTranslation} from "react-i18next";
import ConfirmationPopUp from './confirmationPopUp'
import SucFailViewBillPop from './successFailPopUp'
import GuestSelectDropdown from '../../UI/SelectDropdown'
import { guestDetails, sendAnalytics } from "../../../action/homeAction"
import { calculateTimeDifference, getDefaultAnalyticsLabel, toBool } from '../../JS/utility'
import LoginRequiredOverlay from '../../UI/loginRequiredOverlay'
import { wipeGuestData } from '../../../JS/wipeGuestData'
import { dateFormatHandler } from "../../../JS/dateFormatHandler"

class viewBill2 extends Component {
    constructor(props) {
        super(props)
        this.interval= null
        this.state = {
            selectedGuest: {},
            showGuestList: false,
            emailId: null,
            isCheckoutDate: false,
            showLoadingMask:false,
            showLoader: false,
            checkoutSuccess: false,
            getBillApiCallDelay: 3000,
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidgets.displayName
        }
    }

    componentDidMount() {
       if(!DEMO){
        //    this.setState({showLoadingMask:true})
        //    this.props.setLoaderPopUp(true);
       }
       this.props.SetSelectedGuest('')
        scrollToTop()
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");
        this.props.guestDetails(SessionToken, wipeGuestData, this.props.guestDetail.guestToken, null, this.props.setLoginRequired);
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            // console.log("this.props.currentWidgets",this.props.currentWidgets)
            if (/*this.props.currentWidgets.widgetType && */!room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    // window.history.back();
                    this.props.setLoginRequired(true)
                }
                else {
                    // window.history.back();
                    this.props.setRegPage(true);
                }
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.");
            }
        } else {
            if (this.props.CheckedInGuest.length === 0) {
                // this.setState({showLoadingMask:true})
                // this.props.getGuestInRoom(this.props.guestDetail, () => this.setState({showLoadingMask: false}) );
            } else if (this.props.CheckedInGuest.length == 1) {
                console.log("comparing object works");
                this.setState({ selectedGuest: this.props.CheckedInGuest[0] })
                this.props.SetSelectedGuest(this.props.CheckedInGuest[0])
                this.setState({showLoadingMask:true})
                this.props.guestHistroy(this.props.CheckedInGuest[0], this.guestHisCallBack);
            }
            if (SessionToken) {
                this.props.getServiceID(SessionToken, (status, msg) => {
                    if (!status) {
                        this.props.setFailScreen(true, msg, "We are not not able to get the data, please check your internet connection or try again", true)
                        this.props.setGoHome(true);
                    }
                });
            }
        }

        if(ENABLE_NEW_CHECKOUT_FLOW){
            if(this.props.timeIntervalsBillDetail !== undefined || this.props.timeIntervalsBillDetail !== null){                
            let getBillApiCallDelay = 
            this.props.improvedTimeIntervalsBillDetailApp ?
            this.props.improvedTimeIntervalsBillDetailApp.split(',')[0] * 1000
            : ( this.props.timeIntervalsBillDetail && this.props.timeIntervalsBillDetail.split(',')[2] * 1000);
            
            this.setState({getBillApiCallDelay:getBillApiCallDelay})
            }else{
                this.props.popupOpenClose(true, "CMS configuration error: EXPRESS_CHECKOUT_TIME_INTERVALS is missing");
            }
        }

        this.props.setSuccessFailPop(false, false);
        widgetColors(this.props.menuColor);
        scrollUpListener("div.customOverlay",this.props.menuColor,130);
        $('section#viewMyBill').attr('style', 'padding-top: 0 !important');

        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidgets.displayName, 
                CLICKED, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //

    }

    componentDidUpdate(prevProps, prevState) {
        //console.log("componentDidUpdate");
        // if (prevProps.CheckedInGuest !== this.props.CheckedInGuest &&
        //     this.props.CheckedInGuest.length === 1) {
        //     console.log("comparing object works");
        //     this.setState({ selectedGuest: this.props.CheckedInGuest[0] })
        //     this.props.SetSelectedGuest(this.props.CheckedInGuest[0])
        //     if(this.interval) clearInterval(this.interval)
        //     this.props.guestHistroy(this.props.CheckedInGuest[0], this.guestHisCallBack);
        // }

        if(prevState.selectedGuest != this.state.selectedGuest){


            const serverDateObj = this.props.serverTimeDate && this.props.serverTimeDate.date ? new Date(this.props.serverTimeDate.date.split("T")[0] + "T00:00:00") : new Date();
            const checkoutDateObj = this.state.selectedGuest.plannedCheckOutDate ? new Date(this.state.selectedGuest.plannedCheckOutDate.split("T")[0] + "T00:00:00") : new Date();

            if(serverDateObj == checkoutDateObj){
                this.setState({isCheckoutDate: true});
            } else {
                this.setState({isCheckoutDate: false});   
            }
        }
    }

    componentWillUnmount() {
        this.props.setDefaultBill();
        this.props.currentWidget({})
        removeScrollDown();
        if(this.interval) clearInterval(this.interval);
        if(this.timeout) clearTimeout(this.timeout);

        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.state.widgetName, 
                EXIT, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //

    }

    guestHisCallBack = (status) => {
        if (status) {
            console.log('DEMO',DEMO)
            this.setState({showLoadingMask:true})
            // this.props.guestBillDetails(this.props.selectedGuest, this.callbackBillDetails);
            this.interval = setInterval(() => {
            this.props.guestBillDetails(this.props.selectedGuest,()=>{}, this.callbackViewBill);
        },  this.state.getBillApiCallDelay);
            
            let timeoutInterval=  this.props.improvedTimeIntervalsBillDetailApp ? this.props.improvedTimeIntervalsBillDetailApp.split(',')[1] * 1000 :10000;


            this.timeout = setTimeout(()=>{
                clearInterval(this.interval);
                this.callbackViewBill();
                this.props.openClosePopUp(true, "Something went wrong. While fetching bill");
                this.goBack();
            },timeoutInterval)
    
        } else {
            console.log(" No guest checkedIn.")
        }
    }

    callbackViewBill = () => {
        clearTimeout(this.timeout);
        clearInterval(this.interval)
        this.setState({showLoadingMask:false})
        this.props.setLoaderPopUp(false);
    }
    onCheckOut = (event) => {
        event.preventDefault();
        this.onCheckOutClick();
    }

    extendStay = () => {
        console.log("extend stay called", this.props.extendStayID)
        if (!this.props.selectedGuest.guestName) {
            this.props.openClosePopUp(true, "Please select the guest name from drop down.");
        } else if (this.props.extendStayID) {
            this.props.extendStay(this.props.selectedGuest, this.props.extendStayID, this.onSuccess, this.onFailure);
        }
    }

    onCheckOutClick = () => {
        let emailId = document.getElementById("sendBillEmailID").value
        console.log("emailId", emailId)
        if (this.props.selectedGuest.guestName && (HIDE_EMAIL_FIELD_ON_CHECKOUT || emailId)) {
            this.props.confirmationPop(true);
            this.props.sendGuestMail(this.props.selectedGuest, emailId);
        } else if (!this.props.selectedGuest.guestName) {
            this.props.openClosePopUp(true, this.props.t('view_bill.select-guestname-err'));
        } else if (!emailId) {
            this.props.openClosePopUp(true, this.props.t('view_bill.email-err'));
        }
    }
    onSuccess = (msg) => {
        console.log("onSuccess");
        this.props.openClosePopUp(true, this.props.t('view_bill.successfull-extended-stay'));
    }

    onFailure = (msg) => {
        console.log("onFailure");
        this.props.openClosePopUp(true, this.props.t('view_bill.failed-extended-stay'));
    }

    clickOnGuestList = (guest) => {
        this.props.SetSelectedGuest(guest);
        this.setState({showLoadingMask:true})
        this.setState({ showGuestList: false, selectedGuest:guest });
        this.props.guestHistroy(guest, this.guestHisCallBack);
    }

    showList = () => {
        this.setState({ showGuestList: !this.state.showGuestList });
    }

    goBack = () => {
        this.props.setGoHome(true);
    }

    render() {
        let arrivalDate = this.state.selectedGuest ? this.state.selectedGuest.checkInDate && this.state.selectedGuest.checkInDate !== "null" ? new Date(this.state.selectedGuest.checkInDate) : "" : "";
        let departureDate = this.state.selectedGuest ? this.state.selectedGuest.plannedCheckOutDate && this.state.selectedGuest.plannedCheckOutDate !== "null" ? new Date(this.state.selectedGuest.plannedCheckOutDate) : "" : "";
        // scrollDownEffect(null,"viewBillHeader",this.props.menuColor,14.875);
        const { t } = this.props
        return (
            <div>
                {/*<header class="inner-pages subpages details-page" style = {{display:"none"}}>
                    <a onClick={this.goBack} class="button-back"></a>
                    <div class="heading align-center">
                        <p class="bold">&nbsp;</p>
                    </div>
                </header>*/}
                 <header class="inner-pages subpages details-page" style = {{position:"fixed"}} id="viewBill">
                    <div className = "customOverlay" style = {{transition:"0.3s", position:"absolute",top:"0", left:"0", width: "100%", height:"85px", zIndex:"-1", background:"transparent"}}></div>
                    <a onClick={this.goBack} class="button-back"></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p class="bold" style = {{color:this.props.menuColor.assetFontSelectorColor,textShadow:"unset"}}>{this.props.currentWidgets.displayName}</p> */}
                    </div>
                </header>
                <section class="padding-top-0 widgets detail-item" id = "viewMyBill" >

                    <div class="widget-header">
                        { this.props.currentWidgets.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgets.widgetHeaderImageUrl}`} alt={this.props.currentWidgets.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{this.props.currentWidgets.displayName}</div>
                    </div>

                    <div class="widgets">
                        <div class="row">
                            <div class="row">
                                <div class="col col-2">
                                    <div id = "viewBillHeader"
                                        class="details-header"
                                        style={{ background: this.props.menuColor,//`url('${this.props.currentWidgets.widgetHeaderImageUrl ? CMSPath + this.props.currentWidgets.widgetHeaderImageUrl : this.props.currentWidgets.compImage}')`,
                                        height:"14.875rem"}}
                                    >
                                        <div class="details-header-body" >
                                            {/* <div class="details-body-heading">&nbsp;</div> */}
                                            <div class="details-amount" style = {{display:"block",textAlign:"center",margin:"1rem",color:"#fff", padding:"5rem 0 3rem"}}>
                                                {this.props.currencyCode}{" "}
                                                {this.props.billTotal ? this.props.billTotal : "0"}</div>
                                            {/* <div class="details-subtext">Poolside Villa 1 bedroom</div> */}
                                        </div>
                                    </div>
                                    <div class="detail-body stay-body">
                                        <form>
                                            <div class="stay-info" style = {{boxShadow:"0 4px 13px rgba(0,0,0,0.2)", zIndex:"1",position:"sticky",top:"85px",backgroundColor:"#fff"}}>
                                                {this.props.selectedGuest.guestName && <><div class="stay-arrival">
                                                    <div class="heading">{t('view_bill.arrival')}</div>
                                                    <div class="body" style = {{color:this.props.menuColor.assetBackgroundSelectorColor}}>
                                                        {
                                                            arrivalDate ?
                                                                dateFormatHandler(arrivalDate, this.props.dateFormat)
                                                                : "--"
                                                        }
                                                    </div>
                                                </div>
                                                <div class="stay-departure">
                                                    <div class="heading">{t('view_bill.departure')}</div>
                                                    <div class="body" style = {{color:this.props.menuColor.assetBackgroundSelectorColor}}>
                                                        {
                                                            departureDate ?
                                                                dateFormatHandler(departureDate, this.props.dateFormat)
                                                                : "--"
                                                        }
                                                    </div>
                                                </div></>}
                                                {/*<div class="stay-rate">
                                                    <div class="heading">Fee / Night</div>
                                                    <div class="body" style = {{color:this.props.menuColor.assetBackgroundSelectorColor}}>
                                                        {this.props.currencyCode}&nbsp;
                                                        {this.props.billTotal ? this.props.billTotal : "0"}.00
                                                    </div>
                                                </div>*/} 
                                            </div>
                                            {/* {this.props.billForGuest ? */}
                                            <div class="stay-conrols">
                                                <div class="stay-conrols-container" style = {{backgroundColor: this.props.menuColor.backgroundColor}}>
                                                    { this.props.CheckedInGuest.length > 1 &&
                                                        <GuestSelectDropdown  
                                                            selectedItem={this.props.selectedGuest.guestName}
                                                            listData={this.props.CheckedInGuest}
                                                            styleClass="guest-select tile tile-container"
                                                            showList={this.state.showGuestList}
                                                            parentDivStyle = {{backgroundColor: this.props.menuColor.assetBackgroundSelectorColor}}
                                                            childDivStyle = {{backgroundColor: "inherit",color: this.props.menuColor.assetFontSelectorColor}}
                                                            setShowList={() => this.setState(prev => ({showGuestList: !prev.showGuestList}))}
                                                            setSelectedItem={(obj) => {
                                                                this.clickOnGuestList(obj)
                                                            }}
                                                            selectKey="obj.guestName"
                                                        />
                                                    }
                                                    {/* <div class="subheading">*click on the button to update email</div> */}
                                                </div>
                                                <div class="stay-breakdown">
                                                    <div class="heading">{t('view_bill.purchase')}</div>
                                                    <div class="sub-heading">{t('view_bill.purchase_sub')}</div>
                                                    <div class="body">
                                                        {this.props.billItems.length > 0 ?
                                                            this.props.billItems.map((iterator) => {
                                                                return (
                                                                    <div class="purchase-item" >
                                                                        <div class="purchase-icon" style={{display:'none'}} >
                                                                            <i class="fas fa-utensils"></i>
                                                                        </div>
                                                                        <div class="purchase-desc" style={{marginLeft:'0.5rem'}}>
                                                                            <div class="purchase-desc-text">
                                                                                {iterator.itemDesc}
                                                                            </div>
                                                                            {/* <div class="purchase-desc-date">
                                                                                07-April-2020
                                                                            </div> */}
                                                                        </div>
                                                                        <div class="purchase-amt" style={{textAlign: 'right', marginRight: '1.5rem'}}>
                                                                            <div class="purchase-amt-val">
                                                                                {this.props.currencyCode} {iterator.itemAmount}
                                                                            </div>
                                                                            {/* <div class="purchase-amt-time">
                                                                                06:45 PM
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                            :
                                                            <div class="purchase-item">
                                                                <div class="purchase-desc"
                                                                    style={{ display: "block", width: "inherit", fontSize: "100%", maxWidth: "initial", textAlign: "center" }}>
                                                                    <div class="purchase-desc-text" style={{ width: "100%" }}>{t('view_bill.no_item')}</div>
                                                                </div>
                                                            </div>
                                                        }
                                                         {/*<div class="purchase-item">
                                                                <div class="purchase-icon">
                                                                    <i class="fas fa-utensils"></i>
                                                                </div>
                                                                <div class="purchase-desc">
                                                                    <div class="purchase-desc-text">
                                                                        Room Service: Continnental Breakfast, Pancakes
														            </div>
                                                                    <div class="purchase-desc-date">
                                                                        07-April-2020
														            </div>
                                                                </div>
                                                                <div class="purchase-amt">
                                                                    <div class="purchase-amt-val">
                                                                        $150.00
														            </div>
                                                                    <div class="purchase-amt-time">
                                                                        06:45 PM
														            </div>
                                                                </div>
                                                            </div>
                                                            <div class="purchase-item">
                                                                <div class="purchase-icon">
                                                                    <i class="fas fa-moon"></i>
                                                                </div>
                                                                <div class="purchase-desc">
                                                                    <div class="purchase-desc-text">
                                                                        Overnight Stay Fee
														            </div>
                                                                    <div class="purchase-desc-date">
                                                                        08-April-2020
														            </div>
                                                                </div>
                                                                <div class="purchase-amt">
                                                                    <div class="purchase-amt-val">
                                                                        $500.00
														            </div>
                                                                    <div class="purchase-amt-time">
                                                                        00:00 PM
														            </div>
                                                                </div>
                                                        </div> */}
                                                    </div>

                                                </div>
                                                <div class="stay-conrols-container" style = {{backgroundColor: this.props.menuColor.backgroundColor}}>
                                                    <div class="stay-totals">
                                                        <div class="label">{t('view_bill.total')}</div>
                                
                                                        <div class="value">{this.props.currencyCode} {this.props.billTotal ? this.props.billTotal : 0.00}</div>
                                                    </div>
                                                    <div className="email" style={{display: HIDE_EMAIL_FIELD_ON_CHECKOUT ? 'none' : 'block'}} >
                                                        <div class="heading">{t('view_bill.send_reciept')}</div>
                                                        <div class="body">
                                                            <input id="sendBillEmailID" 
                                                            defaultValue = {this.state.selectedGuest.guestProfile ? this.state.selectedGuest.guestProfile.email : ""}
                                                            type="email" name="email" placeholder={t('view_bill.input_place_order')} style={{ width: "98%", paddingLeft:"0",paddingRight:"0",height:"25px" }} 
                                                            required = {false}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* : <div>
                                                    No bill for this guest
                                        </div>
                                            } */}
                                            <div class="controls-fixed">
                                                {(!this.props.billTotal || +this.props.billTotal <= 0) && <p>{t('view_bill.zero_folio_msg')}</p>}
                                                {this.props.enableCheckoutOnlyOnLastDate && !this.state.isCheckoutDate && <p>{t('view_bill.show_checkout_only_on_checkout')}</p>}
                                                {
                                                    (!this.props.enableCheckoutOnlyOnLastDate || (this.props.enableCheckoutOnlyOnLastDate && this.state.isCheckoutDate)) && 
                                                    <input id="checkoutButton" className={(!this.props.billTotal || +this.props.billTotal <= 0) ? "zero-folio" : undefined} type="submit" name="Checkout" value="Checkout" onClick={this.onCheckOut} />
                                                }
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    this.state.showLoadingMask ?
                        <LoaderPopUp />
                        : null
                } 
                {/* {
                    this.state.showLoader && <Loader displayMsg="Please wait checkout is in process" />
                } */}
                {
                    this.props.ckeckOutConfirm ?
                        <ConfirmationPopUp showLoader={status => this.setState({showLoader:status})} checkoutSuccess={status => {this.setState({checkoutSuccess:status})}} checkoutSuccessStatus={this.state.checkoutSuccess}/>
                        : null
                }
                {/* {
                    this.props.showSucFailPop ?
                        <SucFailViewBillPop showLoader={status => this.setState({showLoader:status})} checkoutSuccess={status => {this.setState({checkoutSuccess:status})}} checkoutSuccessStatus={this.state.checkoutSuccess}/>
                        : null
                } */}
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidgets: state.store.sideNavBar.currentWidget,
        CheckedInGuest: state.store.CheckedInGuest,
        billForGuest: state.store.viewBill.billForGuest,
        billItems: state.store.viewBill.billItems,
        billTotal: state.store.viewBill.billTotal,
        menuColor: state.store.home.MenuColor,
        enableCheckoutOnlyOnLastDate: toBool(state.store2.enableCheckoutOnlyOnLastDate),
        serverTimeDate: state.store.home.serverTimeDate,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        selectedGuest: state.store2.viewBill.selectedGuest,
        extendStayID: state.store.viewBill.extendStayID,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        ckeckOutConfirm: state.store2.viewBill.confirmPop,
        showConfirmPopUP: state.store2.confirmaionPopUp.showPopUP,
        showSucFailPop: state.store2.viewBill.showSucFailPop,
        loaderPopUpShow: state.store2.loaderPopUpShow,
        dateFormat: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        timeIntervalsBillDetail: state.store.home.clientConfig.extraConfigParam 
            ? state.store.home.clientConfig.extraConfigParam.EXPRESS_CHECKOUT_TIME_INTERVALS : "",
        improvedTimeIntervalsBillDetailApp: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.IMPROVED_EXPRESS_CHECKOUT_TIME_INTERVALS_APP : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        guestIsCheckedIn: state.store2.guestIsCheckedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        showLoginRequired: state.store.showLoginRequired,
    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        guestBillDetails,
        popupOpenClose,
        getGuestInRoom,
        setDefaultBill,
        getServiceID,
        guestHistroy,
        checkOut,
        confirmationPop,
        SetSelectedGuest,
        sendGuestMail,
        openClosePopUp,
        setLoaderPopUp,
        extendStay,
        setGoHome,
        currentWidget,
        setSuccessFailPop,
        sendAnalytics,
        guestDetails,
        setLoginRequired,
        setFailScreen
    }
)(withTranslation('translations')(viewBill2));